/* Little Label — Early Black Friday sale layer (see sections/ll-ebf-sale.liquid).
   Display only: prices, stickers, product-page panel, cart progress (free shipping + free gift), cart summary, cart line prices.
   2026-11-02 (v4): "native-aware". When a product carries a real compare-at price in Shopify (the sale is in the
   prices themselves), the theme already renders the strike-through, so this layer leaves prices alone and only
   adds the sticker, the product-page panel (saving read from the real compare-at) and the cart extras.
   When no compare-at exists (old automatic-discount setup) it behaves exactly as before.
   2026-11-03 (v5): savings are shown in dollars ("$34 OFF"), never as a percentage. The headline "up to 40%" lives in the copy settings. */
(function () {
  var S = window.llSale;
  if (!S || window.__llEbf) return;
  window.__llEbf = true;

  var PCT = Number(S.pct) || 40; // headline "up to" number — only a fallback estimate; shown savings are in dollars (2026-11-03)
  var TH = Math.round((Number(S.ship) || 120) * 100);
  var RATE = Number(S.shipRate) || 995;

  function parse(t) {
    var m = /\$\s?([\d,]+(?:\.\d{1,2})?)/.exec(t || '');
    return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : null;
  }
  function fmt(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
  function fmtShort(c) { return fmt(c).replace(/\.00$/, ''); }
  function sale(c) { return c - Math.round(c * PCT / 100); }
  function inCart(el) { return !!(el.closest && el.closest('#CartDrawer, .cart-drawer, [data-ll-cx-offer], .cart-items, .cart-template, .ll-ebf-skip')); }
  function setHTML(el, html) {
    if (!el) return;
    if (el.__ebfIn === html && el.innerHTML === el.__ebfOut) return;
    el.innerHTML = html;
    el.__ebfIn = html;
    el.__ebfOut = el.innerHTML;
  }
  function removeBox(host) {
    var box = host.querySelector(':scope > .ll-ebf-price');
    if (box) box.remove();
    host.classList.remove('ll-ebf-on');
  }
  // Real compare-at price rendered by the theme's price block ($89.00 struck through next to $55.00).
  function nativeOf(host) {
    var old = host.querySelector('.price__old [data-price-old], .price__old .price-item--regular');
    var now = host.querySelector('.price-item--sale');
    var was = old ? parse(old.textContent) : null;
    var cur = now ? (Number(now.getAttribute('data-amount')) || parse(now.textContent)) : null;
    if (was && cur && was > cur) return { was: was, now: cur };
    return null;
  }

  /* ---------- prices ---------- */
  function priceBox(host, cents, from) {
    var box = host.querySelector(':scope > .ll-ebf-price');
    if (!box) { box = document.createElement('div'); box.className = 'll-ebf-price'; host.insertBefore(box, host.firstChild); }
    host.classList.add('ll-ebf-on');
    setHTML(box,
      '<span class="visually-hidden">Regular price</span><s class="ll-ebf-was">' + fmt(cents) + '</s>' +
      '<span class="visually-hidden">Sale price</span><strong class="ll-ebf-now">' + (from ? 'From ' : '') + fmt(sale(cents)) + '</strong>' +
      '<span class="ll-ebf-off">' + fmtShort(cents - sale(cents)) + ' off</span>');
  }
  function doPrices() {
    document.querySelectorAll('.price.js-price, .price.product-price').forEach(function (host) {
      if (inCart(host)) return;
      if (nativeOf(host)) { removeBox(host); return; }
      var src = host.querySelector('.price__regular [data-product-price]') || host.querySelector('.price__regular .price-item--regular');
      if (!src) return;
      var txt = src.textContent;
      var c = parse(txt);
      if (c) priceBox(host, c, /from/i.test(txt));
    });
    document.querySelectorAll('.ll-product-card__price').forEach(function (host) {
      if (inCart(host)) return;
      var themeStrike = host.querySelector('s:not(.ll-ebf-was), del, .ll-product-card__was, [data-compare]');
      if (themeStrike && parse(themeStrike.textContent)) { removeBox(host); return; }
      var src = host.querySelector(':scope > :not(.ll-ebf-price)');
      var c = parse(src ? src.textContent : '');
      if (c) priceBox(host, c, src && /from/i.test(src.textContent));
    });
  }

  /* ---------- stickers ---------- */
  // Dollar saving for a card/page: compare-at minus price, read from the theme's own price markup. null = unknown.
  function saveIn(scope) {
    if (!scope) return null;
    var host = scope.querySelector('.price.js-price, .price.product-price');
    var nat = host && nativeOf(host);
    if (nat) return nat.was - nat.now;
    var llp = scope.querySelector('.ll-product-card__price');
    if (llp) {
      var strike = llp.querySelector('s:not(.ll-ebf-was), del, .ll-product-card__was, [data-compare]');
      var now = llp.querySelector('.ll-ebf-now') || llp.querySelector(':scope > :not(.ll-ebf-price):not(s):not(del)');
      var was = strike ? parse(strike.textContent) : null;
      var cur = now ? parse(now.textContent) : null;
      if (was && cur && was > cur) return was - cur;
    }
    var box = scope.querySelector('.ll-ebf-price .ll-ebf-was');
    var boxNow = scope.querySelector('.ll-ebf-price .ll-ebf-now');
    if (box && boxNow) { var w = parse(box.textContent), n = parse(boxNow.textContent); if (w && n && w > n) return w - n; }
    return null;
  }
  function sticker(host, save) {
    if (!host) return;
    var html = save ? '<b>' + fmtShort(save) + '</b><small>OFF</small>' : '<b>SALE</b>';
    var s = host.querySelector(':scope > .ll-ebf-sticker');
    if (!s) {
      host.classList.add('ll-ebf-sticker-host');
      s = document.createElement('span');
      s.className = 'll-ebf-sticker';
      s.setAttribute('aria-hidden', 'true');
      host.appendChild(s);
    }
    if (s.innerHTML !== html) s.innerHTML = html;
    s.classList.toggle('ll-ebf-sticker--generic', !save);
  }
  function doStickers() {
    document.querySelectorAll('.product-card__image-wrapper').forEach(function (h) {
      if (inCart(h)) return;
      sticker(h, saveIn(h.closest('.product-card, .product-card-with-form, [data-product-card]') || h.parentElement));
    });
    document.querySelectorAll('.ll-product-card').forEach(function (card) {
      var img = card.querySelector('img');
      var h = img && (img.closest('a') || img.parentElement);
      if (h && card.contains(h)) sticker(h, saveIn(card));
    });
    var pdpRow = document.querySelector('[id$="__product-template"] .ll-price-row');
    var pdpSave = pdpRow ? saveIn(pdpRow) : null;
    document.querySelectorAll('.product-media__container').forEach(function (h) { sticker(h, pdpSave); });
  }

  /* ---------- product page panel ---------- */
  function doPdp() {
    var row = document.querySelector('[id$="__product-template"] .ll-price-row');
    if (!row) return;
    var host = row.querySelector('.price') || row;
    var nat = nativeOf(host);
    var c, save;
    if (nat) { c = nat.was; save = nat.was - nat.now; }
    else {
      var src = row.querySelector('.price__regular [data-product-price]');
      c = parse(src ? src.textContent : '');
      if (!c) return;
      save = c - sale(c);
    }
    var p = row.parentElement.querySelector(':scope > .ll-ebf-pdp');
    if (!p) {
      p = document.createElement('div');
      p.className = 'll-ebf-pdp';
      var atc = row.parentElement.querySelector(':scope > .product-add-to-cart');
      (atc || row).insertAdjacentElement('afterend', p);
    }
    setHTML(p,
      '<p class="ll-ebf-pdp__top">Early Black Friday <span>' + fmtShort(save) + ' off</span></p>' +
      '<p class="ll-ebf-pdp__save">You save <strong>' + fmt(save) + '</strong> — already taken off, no code needed.</p>' +
      (G ? '<p class="ll-ebf-pdp__gift"><span aria-hidden="true">🎁</span> Spend $' + G.min + ', get a <strong>free ' + G.name + '</strong> (worth $' + G.value + ')</p>' : '') +
      '<ul class="ll-ebf-pdp__perks"><li>Free shipping over $' + (TH / 100) + '</li><li>Free size exchanges — sale included</li><li>100% organic cotton</li></ul>');
  }

  /* ---------- cart progress: free shipping at $120 + free gift at $175 (cart page + drawer) ---------- */
  var G = S.gwp && S.gwp.variant ? S.gwp : null;
  var gwpBusy = false;
  function doGwp() {
    var hosts = [];
    var pg = document.querySelector('.cart-template__items');
    if (pg) hosts.push({ parent: pg.parentElement, before: pg });
    var dr = document.querySelector('#CartDrawer .cart-drawer__content');
    if (dr) {
      var head = dr.querySelector(':scope > .cart-drawer__heading, :scope > .drawer__header');
      hosts.push({ parent: dr, before: head ? head.nextElementSibling : dr.firstElementChild });
    }
    hosts.forEach(function (h) { renderProg(h.parent, h.before); });
  }
  function renderProg(parent, before) {
    var cart = lastCart;
    var bar = parent.querySelector(':scope > .ll-ebf-prog');
    if (!cart || !cart.item_count) { if (bar) bar.hidden = true; return; }
    if (!bar) { bar = document.createElement('div'); bar.className = 'll-ebf-prog'; parent.insertBefore(bar, before); }
    bar.hidden = false;
    var au = !(window.Shopify && window.Shopify.country) || window.Shopify.country === 'AU';
    var min = G ? Math.round(G.min * 100) : 0;
    var top = G ? min : TH;
    var spend = 0, gift = null;
    cart.items.forEach(function (i) { if (G && String(i.variant_id) === String(G.variant)) gift = i; else spend += i.final_line_price; });
    if (gift && gift.final_line_price < gift.original_line_price) spend = Math.max(spend, min);
    var shipFree = cart.total_price >= TH;
    var giftReady = G && spend >= min;
    var pct = Math.min(100, Math.round(Math.max(spend, shipFree ? TH : 0) * 100 / top));
    var shipPos = Math.round(TH * 100 / top);

    var msg, cta = '';
    if (!au) {
      msg = G ? 'Spend $' + G.min + ' and get a <strong>free ' + G.name + '</strong>' : '';
    } else if (!shipFree) {
      msg = '<strong>' + fmt(TH - cart.total_price) + '</strong> away from free shipping';
    } else if (G && !giftReady) {
      msg = '<span class="ll-ebf-prog__ok">✓ Free shipping</span> · <strong>' + fmt(min - spend) + '</strong> more for a <strong>free ' + G.name + '</strong>';
    } else if (G && !gift) {
      msg = '<span class="ll-ebf-prog__ok">✓ Free shipping</span> · 🎁 <strong>Free ' + G.name + ' unlocked</strong>';
      cta = '<button type="button" class="ll-ebf-prog__add" data-ebf-gwp-add>Add it — it’s free</button>';
    } else if (G) {
      msg = '<span class="ll-ebf-prog__ok">✓ Free shipping</span> · <span class="ll-ebf-prog__ok">✓ Free ' + G.name + ' added</span>';
    } else {
      msg = '<span class="ll-ebf-prog__ok">✓ Free shipping unlocked</span>';
    }
    bar.classList.toggle('is-ship', shipFree);
    bar.classList.toggle('is-gift', !!giftReady);
    setHTML(bar,
      '<p class="ll-ebf-prog__msg">' + msg + '</p>' + cta +
      '<div class="ll-ebf-prog__track" role="progressbar" aria-label="Free shipping and free gift progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '">' +
        '<span class="ll-ebf-prog__fill" style="width:' + pct + '%"></span>' +
        '<i class="ll-ebf-prog__dot' + (shipFree ? ' is-on' : '') + '" style="left:' + shipPos + '%"></i>' +
        (G ? '<i class="ll-ebf-prog__dot' + (giftReady ? ' is-on' : '') + '" style="left:100%"></i>' : '') +
      '</div>' +
      '<div class="ll-ebf-prog__labels">' +
        '<span class="ll-ebf-prog__lbl' + (shipFree ? ' is-on' : '') + '" style="left:' + shipPos + '%"><b>$' + (TH / 100) + '</b>Free shipping</span>' +
        (G ? '<span class="ll-ebf-prog__lbl ll-ebf-prog__lbl--end' + (giftReady ? ' is-on' : '') + '"><b>$' + G.min + '</b>Free ' + G.name.replace(/^Bloom /, '') + '</span>' : '') +
      '</div>' +
      '<p class="ll-ebf-prog__note">Sale prices already applied · No code needed</p>');
  }
  function refreshCartUi() {
    var tc = window.themeCore;
    var p = tc && tc.CartApi && tc.CartApi.makeRequest
      ? Promise.resolve(tc.CartApi.makeRequest(tc.CartApi.actions.GET_CART, { noOpen: true })).catch(function () {})
      : Promise.resolve();
    return p.then(function () {
      if (tc && tc.EventBus) tc.EventBus.emit('cart:refresh');
      document.dispatchEvent(new CustomEvent('ll:cart-changed'));
      if (/^\/cart\/?$/.test(location.pathname)) location.reload();
      return fetchCart();
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ebf-gwp-add]');
    if (!b || gwpBusy) return;
    e.preventDefault();
    gwpBusy = true;
    b.disabled = true; b.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(G.variant), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return refreshCartUi(); })
      .catch(function () { b.disabled = false; b.textContent = 'Try again'; })
      .then(function () { gwpBusy = false; });
  });

  /* ---------- copy that changes with the sale ---------- */
  function doCopy() {
    document.querySelectorAll('.ll-trust-line').forEach(function (el) {
      setHTML(el, 'Free shipping over $' + (TH / 100) + ' &middot; Free size exchange &middot; Australian owned');
    });
    document.querySelectorAll('.ll-trust-row__text').forEach(function (el) {
      if (/free au shipping|on every order/i.test(el.textContent)) setHTML(el, 'Free shipping<br><small>On orders over $' + (TH / 100) + '</small>');
    });
    if (S.shopHeading && !doCopy.shopDone) {
      document.querySelectorAll('[id*="ll_little_bloom_shop"] p, [id*="ll_little_bloom_shop"] span').forEach(function (el) {
        if (el.children.length === 0 && /^(Prices shown are before the 30%|Full prices shown)/.test(el.textContent.trim())) { el.textContent = S.shopHeading; doCopy.shopDone = true; }
      });
    }
  }

  /* ---------- cart: message, recommendation prices, shipping, summary ---------- */
  var lastCart = null;
  var tick = '<svg class="ll-ship__icon" aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="14" height="14"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function catalog() {
    var el = document.querySelector('[data-ll-cx-catalog]');
    if (!el) return {};
    if (el.__map) return el.__map;
    var map = {}, vmap = {}, native = false;
    try {
      JSON.parse(el.textContent).forEach(function (p) {
        map[p.id] = p;
        if (p.compare && p.compare > p.price) native = true;
        (p.variants || []).forEach(function (v) { vmap[v.id] = { price: v.price, compare: v.compare || p.compare || 0 }; });
      });
    } catch (e) {}
    map.__variants = vmap;
    map.__native = native;
    el.__map = map;
    return map;
  }
  // Savings when the sale lives in the prices (compare-at): sum of (compare-at − price) × qty for Little Bloom lines,
  // plus a PCT estimate for anything not in the catalog.
  function nativeSaved(cart, cat) {
    var saved = 0, vm = cat.__variants || {};
    cart.items.forEach(function (i) {
      var v = vm[i.variant_id];
      if (v && v.compare > v.price) saved += (v.compare - v.price) * i.quantity;
      else if (!v) saved += Math.round(i.original_price * PCT / (100 - PCT)) * i.quantity;
    });
    return saved;
  }
  function doCart() {
    var cart = lastCart;
    if (!cart || !cart.items) return;
    var au = !(window.Shopify && window.Shopify.country) || window.Shopify.country === 'AU';
    var total = cart.total_price;
    var free = total >= TH;
    var cat = catalog();
    var NATIVE = !!cat.__native;

    document.querySelectorAll('[data-ll-cx-msg]').forEach(function (m) {
      if (!cart.item_count) return;
      m.hidden = false;
      m.className = 'll-cx-msg is-active ll-ebf-msg';
      setHTML(m, '<span class="ll-cx-msg__l1"><span class="ll-cx-msg__tick" aria-hidden="true">✓</span>' + (S.msg1 || '') + '</span>' +
        (S.msg2 ? '<span class="ll-cx-msg__l2">' + S.msg2 + '</span>' : ''));
    });

    document.querySelectorAll('[data-ll-cx-card]').forEach(function (card) {
      var p = cat[card.getAttribute('data-pid')];
      var el = card.querySelector('[data-ll-cx-price]');
      if (!p || !el) return;
      var tag = card.classList.contains('is-in-cart') ? ' <span class="ll-cx-card__tag">In cart</span>' : '';
      var was, now;
      if (p.compare && p.compare > p.price) { was = p.compare; now = p.price; }
      else if (NATIVE) { was = null; now = p.price; }
      else { was = p.price; now = sale(p.price); }
      setHTML(el, (was ? '<s class="ll-cx-card__was"><span class="visually-hidden">Was </span>' + fmt(was).replace(/\.00$/, '') + '</s> ' : '') +
        '<span class="ll-cx-card__now">' + fmt(now) + '</span>' + (was ? ' <span class="ll-cx-card__when">' + fmtShort(was - now) + ' off</span>' : '') + tag);
      var bag = card.querySelector('.ll-cx-card__bag');
      if (bag) bag.remove();
    });

    if (!au) return;
    document.querySelectorAll('[data-ll-ship]').forEach(function (el) {
      if (!cart.item_count) return;
      el.hidden = false;
      el.classList.toggle('is-free', free);
      el.classList.remove('ll-ship--always');
      setHTML(el.querySelector('[data-ll-ship-msg]'), free
        ? tick + 'Free shipping unlocked'
        : 'You’re <strong>' + fmt(TH - total) + '</strong> away from free shipping');
      var tr = el.querySelector('[data-ll-ship-track]');
      if (tr) {
        tr.hidden = false;
        var pct = Math.min(100, Math.floor(total * 100 / TH));
        tr.setAttribute('aria-valuenow', String(pct));
        var f = tr.querySelector('.ll-ship__fill');
        if (f && f.style.width !== pct + '%') f.style.width = pct + '%';
      }
    });
    document.querySelectorAll('[data-ll-sum]').forEach(function (el) {
      var disc = Math.max(0, (cart.original_total_price || 0) - total);
      var saved = (NATIVE ? nativeSaved(cart, cat) + disc : disc) + (free ? RATE : 0);
      var row = el.querySelector('.ll-sum__row--save');
      if (row) row.classList.toggle('is-zero', saved <= 0);
      setHTML(el.querySelector('[data-ll-sum-savings]'), saved > 0 ? '−' + fmt(saved) : fmt(0));
      setHTML(el.querySelector('[data-ll-sum-ship]'), free ? '<s class="ll-sum__was">' + fmt(RATE) + '</s> <span class="ll-sum__free">FREE</span>' : fmt(RATE));
      setHTML(el.querySelector('[data-ll-sum-total]'), fmt(total + (free ? 0 : RATE)));
    });
  }
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; schedule(); })
      .catch(function () {});
  }

  /* ---------- cart line items: strike the full price, show the sale price (order-level discount only).
     With compare-at pricing the theme already shows the strike-through, so this does nothing. ---------- */
  function doCartLines() {
    var cart = lastCart;
    if (catalog().__native) return;
    document.querySelectorAll('#CartDrawer .cart-item, .cart-template .cart-item, .cart-items .cart-item').forEach(function (item) {
      if (item.querySelector('.cart-item__price--old')) return;
      var key = item.getAttribute('data-cart-item');
      var line = null;
      if (cart && cart.items) cart.items.forEach(function (i) { if (i.key === key) line = i; });
      if (line && line.final_line_price < line.original_line_price) return;
      if (G && line && String(line.variant_id) === String(G.variant)) return;
      item.querySelectorAll('.cart-item__prices, .cart-item__price-total, .cart-item__summary').forEach(function (host) {
        var src = host.querySelector('.cart-item__price:not(.ll-ebf-was):not(.ll-ebf-now)');
        if (!src) return;
        var c = parse(src.textContent);
        if (!c) return;
        host.classList.add('ll-ebf-line');
        var box = host.querySelector(':scope > .ll-ebf-price');
        if (!box) { box = document.createElement('div'); box.className = 'll-ebf-price ll-ebf-price--line'; host.insertBefore(box, host.firstChild); }
        setHTML(box,
          '<span class="visually-hidden">Regular price</span><s class="ll-ebf-was">' + fmt(c) + '</s>' +
          '<span class="visually-hidden">Sale price</span><strong class="ll-ebf-now">' + fmt(sale(c)) + '</strong>');
      });
    });
  }

  /* ---------- run + re-run when the page changes ---------- */
  function run() { doPrices(); doStickers(); doPdp(); doCopy(); doCart(); doCartLines(); doGwp(); }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; run(); }, 30);
  }
  function boot() {
    run();
    fetchCart();
    var refetchT = null;
    new MutationObserver(function (muts) {
      schedule();
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('#CartDrawer, .cart-template') && !(t.closest('.ll-ebf-prog'))) {
          clearTimeout(refetchT); refetchT = setTimeout(fetchCart, 250); break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    var tc = window.themeCore;
    if (tc && tc.EventBus) tc.EventBus.listen('cart:updated', function (c) { if (c && c.items) { lastCart = c; } setTimeout(fetchCart, 150); });
    document.addEventListener('ll:cart-changed', function () { setTimeout(fetchCart, 150); });
    document.addEventListener('theme:all:loaded', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
